import React from "react";
import ErrorDisplay from "./ErrorDisplay";

const ValidationMessage = ({ condition, errorMsg }) => {
  return condition ? <ErrorDisplay errorMsg={errorMsg} /> : null;
};

export default ValidationMessage; 
